import { Component, Input } from '@angular/core';
import { faAngleDown, faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { AgendaItem, Event } from '@rensa/modules/customer/models/event.model';
import { slideAnimation } from '@rensa/shared/animations';
import { environment } from '@rensa/environments/environment';
import { DatePipe } from '@angular/common';
import { ButtonType } from '@rensa/shared/enums/button-type.enum';

@Component({
  selector: 'app-event-table',
  templateUrl: './event-table.component.html',
  styleUrls: ['./event-table.component.css'],
  animations: slideAnimation
})
export class EventTableComponent {

  @Input() events: Event[];
  @Input() trainingId: string;
  @Input() location: string;
  @Input() trainingTitle: string;

  ButtonType = ButtonType;
  faArrowRight = faArrowRight;
  faAngleDown = faAngleDown;
  faCheck = faCheck;

  durationTable = [];

  showPane = [];

  constructor(private datePipe: DatePipe) {
  }

  secondsToMilliSeconds(seconds: number): number {
    return seconds * 1000;
  }

  tillTime(startTime: number, agenda: AgendaItem[]): number {
    const totalTime = agenda.reduce((total, item) => total + item.duration, 0);
    return this.secondsToMilliSeconds(startTime + (totalTime * 60));
  }

  totalTime(eventId: string, startTime: number, agenda: AgendaItem[]): void {
    const total = agenda.map(((sum: number) => (item: AgendaItem) => sum += item.duration * 60 * 1000)(startTime * 1000));
    total.unshift(startTime * 1000);
    this.durationTable[eventId] = total;
  }

  togglePane(id: number): void {
    this.showPane[id] = this.showPane[id] === undefined || this.showPane[id] === false;
  }

  getLinkToSubscription(id: string): string {
    return `/${this.trainingId}/${id}`;
  }

  getSendToUri(eventId: string | undefined, location: string | undefined, date: number | undefined): string {
    const subject = environment.sendToEmail[environment.itemType].subject;
    let body = environment.sendToEmail[environment.itemType].itemDetail.body;

    body = body.replace('{{location}}', location)
      .replace('{{title}}', this.trainingTitle)


    if (date) {
      const dateObj = new Date(date * 1000);
      const formattedDateString = this.datePipe.transform(dateObj,'EEEE dd MMMM yyyy', 'nl-NL');

      body = body.replace('{{date}}', formattedDateString)
        .replace('{{link}}', `${environment.frontendUrl}/${this.trainingId}/${eventId}`);
    } else {
      body = body.replace(' op {{date}}', '')
        .replace('{{link}}', `${environment.frontendUrl}/${this.trainingId}`)
        .replace(' en meld je aan', '');
    }

    return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  getAvailableRegistrations(event: Event) {
    return !event.allowNewRegistrations ? 0 : event.maxAttendees - event.numberOfAttendees;
  }

  isRegistrationOpen(event: Event) {
    return event.startDateTime > 0 &&
      event.numberOfAttendees < event.maxAttendees &&
      event.allowNewRegistrations;
  }

  isGuestlistOpen(event: Event) {
    return event.startDateTime > 0 &&
      event.enableGuestlist &&
      (event.numberOfAttendees === event.maxAttendees || !event.allowNewRegistrations);
  }
}
